document.addEventListener('DOMContentLoaded', () => {
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuToggle && mobileMenu) {
    const closeMenu = () => {
      mobileMenu.hidden = true;
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('menu-open');
      menuToggle.focus();
    };
    menuToggle.addEventListener('click', () => {
      const open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
      document.body.classList.toggle('menu-open', open);
      if (open) mobileMenu.querySelector('[data-menu-close]')?.focus();
    });
    mobileMenu.querySelector('[data-menu-close]')?.addEventListener('click', closeMenu);
    mobileMenu.querySelectorAll('a').forEach((link) => link.addEventListener('click', closeMenu));
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !mobileMenu.hidden) closeMenu();
    });
  }

  const touchProductCards = window.matchMedia('(max-width: 720px)');
  let activeTouchProductCard = null;
  let touchGestureCard = null;
  let touchGestureStartedWithPreview = false;
  let touchGestureMoved = false;
  let touchGestureStartX = 0;
  let touchGestureStartY = 0;
  let touchGestureSequence = 0;
  let pendingTouchPoint = null;
  let touchFramePending = false;
  const requestTouchFrame = window.requestAnimationFrame || ((callback) => setTimeout(callback, 16));
  const resetTouchGesture = () => {
    touchGestureCard = null;
    touchGestureStartedWithPreview = false;
    touchGestureMoved = false;
  };
  const finishTouchGesture = () => {
    const sequence = touchGestureSequence;
    setTimeout(() => {
      if (sequence === touchGestureSequence) resetTouchGesture();
    }, 600);
  };
  const clearTouchProductPreview = () => {
    activeTouchProductCard?.classList.remove('is-touch-preview');
    activeTouchProductCard = null;
  };
  const activateTouchProductPreview = (card) => {
    if (activeTouchProductCard === card) return;
    clearTouchProductPreview();
    card.classList.add('is-touch-preview');
    activeTouchProductCard = card;
  };
  const productCardAtPoint = (x, y) => {
    const media = document.elementFromPoint(x, y)?.closest?.('.product-card__image');
    const card = media?.closest?.('.product-card');
    return card?.querySelector('.product-card__image-hover') ? card : null;
  };
  const updateTouchPreview = () => {
    touchFramePending = false;
    if (!pendingTouchPoint) return;
    const card = productCardAtPoint(pendingTouchPoint.x, pendingTouchPoint.y);
    pendingTouchPoint = null;
    if (!card) return;
    if (card !== touchGestureCard) touchGestureMoved = true;
    touchGestureCard = card;
    activateTouchProductPreview(card);
  };
  const previewImageObserver = typeof window.IntersectionObserver === 'function' ? new window.IntersectionObserver((entries, observer) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.loading = 'eager';
      entry.target.decode?.().catch(() => {});
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '400px 0px' }) : null;
  document.querySelectorAll('.product-card').forEach((card) => {
    const link = card.querySelector('a');
    const media = card.querySelector('.product-card__image');
    const preview = card.querySelector('.product-card__image-hover');
    if (!link || !media || !preview) return;
    previewImageObserver?.observe(preview);
    let previewActivatedOnPointerDown = false;
    let productTouchMoved = false;
    let productTouchStartX = 0;
    let productTouchStartY = 0;
    media.addEventListener('pointerdown', (event) => {
      if (!touchProductCards.matches || event.pointerType === 'touch') return;
      touchGestureSequence += 1;
      resetTouchGesture();
      previewActivatedOnPointerDown = !card.classList.contains('is-touch-preview');
      productTouchMoved = false;
      productTouchStartX = event.clientX;
      productTouchStartY = event.clientY;
      if (!previewActivatedOnPointerDown) return;
      activateTouchProductPreview(card);
    }, { passive: true });
    media.addEventListener('pointermove', (event) => {
      if (!touchProductCards.matches || event.pointerType === 'touch') return;
      if (Math.abs(event.clientX - productTouchStartX) > 8 || Math.abs(event.clientY - productTouchStartY) > 8) productTouchMoved = true;
    }, { passive: true });
    link.addEventListener('click', (event) => {
      if (!touchProductCards.matches || !media.contains(event.target)) return;
      if (touchGestureMoved) {
        event.preventDefault();
        touchGestureSequence += 1;
        resetTouchGesture();
        return;
      }
      if (touchGestureCard === card) {
        const preventNavigation = !touchGestureStartedWithPreview || touchGestureMoved;
        touchGestureSequence += 1;
        resetTouchGesture();
        if (preventNavigation) event.preventDefault();
        return;
      }
      if (previewActivatedOnPointerDown || productTouchMoved) {
        event.preventDefault();
        previewActivatedOnPointerDown = false;
        productTouchMoved = false;
        return;
      }
      if (card.classList.contains('is-touch-preview')) return;
      event.preventDefault();
      activateTouchProductPreview(card);
    });
  });
  document.addEventListener('touchstart', (event) => {
    if (!touchProductCards.matches) return;
    const touch = event.touches[0];
    if (!touch) return;
    touchGestureSequence += 1;
    touchGestureStartX = touch.clientX;
    touchGestureStartY = touch.clientY;
    touchGestureMoved = false;
    touchGestureCard = productCardAtPoint(touch.clientX, touch.clientY);
    touchGestureStartedWithPreview = Boolean(touchGestureCard?.classList.contains('is-touch-preview'));
    if (touchGestureCard) activateTouchProductPreview(touchGestureCard);
  }, { passive: true });
  document.addEventListener('touchmove', (event) => {
    if (!touchProductCards.matches) return;
    const touch = event.touches[0];
    if (!touch) return;
    if (Math.abs(touch.clientX - touchGestureStartX) > 8 || Math.abs(touch.clientY - touchGestureStartY) > 8) touchGestureMoved = true;
    pendingTouchPoint = { x: touch.clientX, y: touch.clientY };
    if (touchFramePending) return;
    touchFramePending = true;
    requestTouchFrame(updateTouchPreview);
  }, { passive: true });
  document.addEventListener('touchend', finishTouchGesture, { passive: true });
  document.addEventListener('touchcancel', () => {
    touchGestureSequence += 1;
    pendingTouchPoint = null;
    resetTouchGesture();
  }, { passive: true });
  document.addEventListener('pointerdown', (event) => {
    if (activeTouchProductCard && !activeTouchProductCard.contains(event.target)) clearTouchProductPreview();
  });
  touchProductCards.addEventListener('change', () => {
    if (!touchProductCards.matches) clearTouchProductPreview();
  });

  const gift = document.querySelector('[data-welcome-gift]');
  if (gift) {
    const hasWelcomeSuccess = Boolean(gift.querySelector('[data-welcome-success]'));
    if (hasWelcomeSuccess) {
      gift.hidden = false;
      gift.classList.add('is-success');
    } else if (!sessionStorage.getItem('nelora-welcome-dismissed')) {
    const hero = document.querySelector('[data-hero]');
    let delayComplete = false;
    const revealGift = () => {
      if (!delayComplete || (hero && window.scrollY < hero.offsetHeight - 80)) return;
      gift.hidden = false;
      window.removeEventListener('scroll', revealGift);
    };
    window.setTimeout(() => { delayComplete = true; revealGift(); }, Number(gift.dataset.delay || 4000));
    window.addEventListener('scroll', revealGift, { passive: true });
      gift.querySelector('[data-welcome-close]')?.addEventListener('click', () => {
        gift.hidden = true;
        sessionStorage.setItem('nelora-welcome-dismissed', 'true');
      });
    }
  }

  document.querySelectorAll('[data-product]').forEach((root) => {
    const variantsNode = root.querySelector('[data-product-variants]');
    if (!variantsNode) return;
    const variants = JSON.parse(variantsNode.textContent);
    const selected = [...root.querySelectorAll('[data-option-value].is-selected')].map((button) => button.dataset.optionValue);
    const variantInput = root.querySelector('[data-variant-id]');
    const price = root.querySelector('[data-price]');
    const add = root.querySelector('.product-page__add');
    const form = root.querySelector('[data-product-form]');
    const updateVariantSpecifications = (root, variant) => {
      root.querySelectorAll('[data-product-spec-option-position]').forEach((item) => {
        const position = Number(item.dataset.productSpecOptionPosition);
        const value = variant.options[position - 1] || '';
        const valueNode = item.querySelector('[data-product-spec-value]');
        if (valueNode) valueNode.textContent = value;
        item.hidden = !value;
      });

      const skuItem = root.querySelector('[data-product-spec-sku]');
      if (skuItem) {
        const skuValue = skuItem.querySelector('[data-product-spec-value]');
        if (skuValue) skuValue.textContent = variant.sku || '';
        skuItem.hidden = !variant.sku;
      }

      const specifications = root.querySelector('[data-product-specifications]');
      if (specifications) {
        const visibleItems = [...specifications.querySelectorAll('li')].some((item) => !item.hidden);
        specifications.hidden = !visibleItems;
      }
    };
    const initialVariant = variants.find((entry) => entry.options.every((value, index) => value === selected[index]));
    if (initialVariant) updateVariantSpecifications(root, initialVariant);
    const showVariantPreview = (button) => {
      const fieldset = button.closest('.variant-options');
      const preview = fieldset?.querySelector('[data-variant-preview]');
      const image = preview?.querySelector('[data-variant-preview-image]');
      const source = button.dataset.optionPreview;
      if (!preview || !image || !source) return;
      const buttonRect = button.getBoundingClientRect();
      const fieldsetRect = fieldset.getBoundingClientRect();
      preview.style.left = `${buttonRect.left - fieldsetRect.left + (buttonRect.width / 2)}px`;
      image.src = source;
      image.alt = button.textContent.trim();
      preview.hidden = false;
    };
    const hideVariantPreview = (button) => {
      button.closest('.variant-options')?.querySelector('[data-variant-preview]')?.setAttribute('hidden', '');
    };
    const showMedia = (id) => {
      root.querySelectorAll('[data-media-id]').forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaId) === String(id)));
      root.querySelectorAll('[data-media-trigger]').forEach((node) => node.classList.toggle('is-active', String(node.dataset.mediaTrigger) === String(id)));
    };
    root.querySelectorAll('[data-media-trigger]').forEach((button) => button.addEventListener('click', () => showMedia(button.dataset.mediaTrigger)));
    root.querySelectorAll('[data-option-value]').forEach((button) => {
      button.addEventListener('pointerenter', () => {
        if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) showVariantPreview(button);
      });
      button.addEventListener('pointerleave', () => hideVariantPreview(button));
      button.addEventListener('focus', () => showVariantPreview(button));
      button.addEventListener('blur', () => hideVariantPreview(button));
      button.addEventListener('click', () => {
      const fieldset = button.closest('fieldset');
      fieldset.querySelectorAll('[data-option-value]').forEach((node) => {
        node.classList.remove('is-selected');
        node.setAttribute('aria-pressed', 'false');
      });
      button.classList.add('is-selected');
      button.setAttribute('aria-pressed', 'true');
      const values = [...root.querySelectorAll('[data-option-value].is-selected')].map((node) => node.dataset.optionValue);
      const variant = variants.find((entry) => entry.options.every((value, index) => value === values[index]));
      if (!variant) return;
      updateVariantSpecifications(root, variant);
      variantInput.value = variant.id;
      price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency: window.Shopify?.currency?.active || 'USD' }).format(variant.price / 100);
      add.disabled = !variant.available;
      add.textContent = variant.available ? form.dataset.addLabel : form.dataset.soldOutLabel;
      if (variant.featured_media?.id) showMedia(variant.featured_media.id);
      window.history.replaceState({}, '', `${window.location.pathname}?variant=${variant.id}`);
      });
    });
  });

  const galleryLightbox = document.querySelector('[data-gallery-lightbox]');
  if (galleryLightbox) {
    const image = galleryLightbox.querySelector('[data-gallery-lightbox-image]');
    const caption = galleryLightbox.querySelector('[data-gallery-lightbox-caption]');
    const openers = [...document.querySelectorAll('[data-gallery-lightbox-open]')];
    const thumbs = [...galleryLightbox.querySelectorAll('[data-gallery-lightbox-thumb]')];
    let activeIndex = 0;

    const showGalleryImage = (index) => {
      activeIndex = (index + openers.length) % openers.length;
      const opener = openers[activeIndex];
      const sourceImage = opener?.querySelector('img');
      const source = opener?.dataset.gallerySource;
      if (!source) return;
      image.removeAttribute('srcset');
      image.src = source;
      image.alt = sourceImage?.alt || '';
      caption.textContent = `${activeIndex + 1} / ${openers.length}`;
      thumbs.forEach((thumb, thumbIndex) => thumb.classList.toggle('is-active', thumbIndex === activeIndex));
    };

    const closeGalleryLightbox = () => {
      galleryLightbox.close();
    };

    const openGalleryLightbox = (index) => {
      showGalleryImage(index);
      galleryLightbox.showModal();
      galleryLightbox.querySelector('[data-gallery-lightbox-close]')?.focus();
    };

    openers.forEach((opener, index) => opener.addEventListener('click', () => openGalleryLightbox(index)));
    thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showGalleryImage(index)));
    galleryLightbox.querySelector('[data-gallery-lightbox-close]')?.addEventListener('click', closeGalleryLightbox);
    galleryLightbox.querySelector('[data-gallery-lightbox-previous]')?.addEventListener('click', () => showGalleryImage(activeIndex - 1));
    galleryLightbox.querySelector('[data-gallery-lightbox-next]')?.addEventListener('click', () => showGalleryImage(activeIndex + 1));
    galleryLightbox.addEventListener('click', (event) => {
      if (event.target === galleryLightbox) closeGalleryLightbox();
    });
    galleryLightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') showGalleryImage(activeIndex - 1);
      if (event.key === 'ArrowRight') showGalleryImage(activeIndex + 1);
    });
  }

  const collectionCatalog = document.querySelector('[data-collection-catalog]');
  if (collectionCatalog) {
    const filters = collectionCatalog.querySelector('[data-collection-filters]');
    const openFilters = collectionCatalog.querySelector('[data-collection-filters-toggle]');
    const closeFilters = collectionCatalog.querySelector('[data-collection-filters-close]');
    const mobileLayout = window.matchMedia('(max-width: 720px)');
    const closeCollectionFilters = () => {
      if (!filters) return;
      filters.hidden = true;
      openFilters?.setAttribute('aria-expanded', 'false');
    };
    openFilters?.addEventListener('click', () => {
      if (!filters) return;
      filters.hidden = false;
      openFilters.setAttribute('aria-expanded', 'true');
      closeFilters?.focus();
    });
    closeFilters?.addEventListener('click', closeCollectionFilters);
    const setCollectionFiltersLayout = () => {
      if (!filters) return;
      if (mobileLayout.matches) filters.hidden = true;
      else filters.hidden = false;
    };
    setCollectionFiltersLayout();
    mobileLayout.addEventListener('change', setCollectionFiltersLayout);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && filters && !filters.hidden) closeCollectionFilters();
    });
  }
});
